import React from 'react';
import moment from 'moment';
import { convertDays } from 'shared-utils';
import { DateSlotsCard } from './DateSlotsCard';

type Props = {
    allSlots: any; // DayTimeSlot[];
    selectedDaySlot?: any; // DayTimeSlot;
    setSelectedDaySlot: (value: any) => void;
};

export const EligibilityDateSelection = ({ allSlots, selectedDaySlot, setSelectedDaySlot }: Props) => {
    return (
        <div className="flex flex-col py-2 md:max-w-[574px] mb-0">
            <p className="text-[#544D4F] font-inter text-[16px] font-[700] leading-[20px]">Select date</p>
            <div className="p-2 pl-0 overflow-x-auto scrollPracticeTopics" id="date_selection_scroll_div_container">
                <div className="flex gap-4 " id="date_selection_scroll_div">
                    {/* allSlots */}
                    {allSlots?.map((availability: any, ind: number) => {
                        const isSelected = selectedDaySlot?.date === availability.date;
                        return (
                            <DateSlotsCard
                                key={ind}
                                day={convertDays(availability.day).slice(0, 3).toUpperCase()}
                                date={moment(availability.date).format('DD MMM')}
                                slotAvailable={availability.totalSlots}
                                isSelected={isSelected}
                                startTime={availability.date}
                                setSelectedDaySlot={setSelectedDaySlot}
                                availability={availability}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};
